var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"user-create__view"}},[_c('user-form',{attrs:{"form":_vm.form,"has-aad-license":_vm.checkAzureADLicence(),"handler":_vm.editUser,"is-edit-mode":""}}),(_vm.isLoading)?_c('sp-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }